export var validatePassword = function (password) {
    return !!password.match(/^(?=.*\d)(?=.*[!@#$%^&*()_+{}|:;"'<>,.?/`~-]).*$/);
};
export var validateAlpha = function (alpha) {
    return !!alpha.match(/^[a-zA-Z]+$/);
};
export var validateCommaFloat = function (number) {
    // number must contain only digits with dot or comma separators
    return !!number.match(/^\d+([.,]\d+)?$/);
};
export var inBrowser = typeof window !== 'undefined';
